import { render, staticRenderFns } from "./UtaDashboard.vue?vue&type=template&id=74d47869&scoped=true&"
import script from "./UtaDashboard.vue?vue&type=script&lang=js&"
export * from "./UtaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UtaDashboard.vue?vue&type=style&index=0&id=74d47869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d47869",
  null
  
)

export default component.exports